import { NavLink } from "react-router";

import accountIcon from "@/assets/figma/settings/account.svg";
import adsIcon from "@/assets/figma/settings/ads.svg";
import emailIcon from "@/assets/figma/settings/email.svg";
import notificationIcon from "@/assets/figma/settings/notification.svg";
import plansIcon from "@/assets/figma/settings/plans.svg";
import storeIcon from "@/assets/figma/settings/store-nav.svg";
import supportIcon from "@/assets/figma/settings/support.svg";
import tasksIcon from "@/assets/figma/settings/tasks.svg";
import teamIcon from "@/assets/figma/settings/team.svg";
import backIcon from "@/assets/figma/settings/back.svg";
import { cn } from "@/shared/lib/cn";
import { Button } from "react-aria-components";

interface SettingsNavigationItem {
  iconSource: string;
  id: string;
  label: string;
  to?: string;
}

const settingsNavigationGroups: ReadonlyArray<{
  id: string;
  items: ReadonlyArray<SettingsNavigationItem>;
  label: string;
}> = [
  {
    id: "account",
    label: "账户设置",
    items: [
      {
        iconSource: accountIcon,
        id: "account-information",
        label: "账号信息",
        to: "/settings/account",
      },
      {
        iconSource: notificationIcon,
        id: "notifications",
        label: "通知管理",
        to: "/settings/notifications",
      },
      {
        iconSource: plansIcon,
        id: "plans",
        label: "套餐与充值",
        to: "/settings/billing",
      },
      {
        iconSource: supportIcon,
        id: "support",
        label: "帮助与支持",
        to: "/settings/support",
      },
    ],
  },
  {
    id: "configuration",
    label: "配置管理",
    items: [
      {
        iconSource: emailIcon,
        id: "connections",
        label: "应用连接",
        to: "/settings/connections",
      },
      {
        iconSource: storeIcon,
        id: "stores",
        label: "店铺管理",
        to: "/settings/stores",
      },
      {
        iconSource: teamIcon,
        id: "team",
        label: "团队管理",
        to: "/settings/team",
      },
      {
        iconSource: adsIcon,
        id: "ads",
        label: "广告户管理",
        to: "/settings/ads",
      },
      {
        iconSource: tasksIcon,
        id: "tasks",
        label: "定时任务管理",
        to: "/settings/tasks",
      },
    ],
  },
];

export function MerrySettingsNavigation() {
  return (
    <nav
      aria-label="设置面板导航"
      className="merry-settings-navigation"
      data-figma-component-id="516:105669"
    >
      {settingsNavigationGroups.map((group) => (
        <section className="merry-settings-navigation__group" key={group.id}>
          <h2 className="merry-settings-navigation__group-title">
            {group.label}
          </h2>
          <div className="merry-settings-navigation__items">
            {group.items.map((item) =>
              item.to ? (
                <NavLink
                  className={({ isActive }) =>
                    cn(
                      "merry-settings-navigation__item",
                      isActive && "merry-settings-navigation__item--active",
                    )
                  }
                  data-settings-navigation-item={item.id}
                  key={item.id}
                  to={item.to}
                >
                  <img alt="" aria-hidden="true" src={item.iconSource} />
                  <span>{item.label}</span>
                </NavLink>
              ) : (
                <span
                  aria-disabled="true"
                  className="merry-settings-navigation__item"
                  data-settings-navigation-item={item.id}
                  key={item.id}
                >
                  <img alt="" aria-hidden="true" src={item.iconSource} />
                  <span>{item.label}</span>
                </span>
              ),
            )}
          </div>
        </section>
      ))}
    </nav>
  );
}

export function MerrySettingsTitle({ onBack }: { onBack: () => void }) {
  return (
    <div className="merry-settings-title">
      <Button
        aria-label="返回工作台"
        className="merry-settings-title__back"
        onPress={onBack}
      >
        <img alt="" aria-hidden="true" src={backIcon} />
      </Button>
      <h1 className="merry-desktop-shell-page-title">设置面板</h1>
    </div>
  );
}
